<template>
  <notifications
    position="bottom right"
    :width="mobile ? '100vw' : '30vw'"
    min-width="400px"
    pause-on-hover
    :duration="3000">
    <template #body="props">
      <cc-alert
        :color="color(props.item)"
        :icon="props.item.data?.icon || 'mdi-bell'"
        class="ma-2 pb-2 border-s-lg"
        :class="props.item.data?.achievement ? 'achievement-pulse' : ''"
        style="position: relative"
        tile
        :title="props.item.title"
        @click.stop="closePopup(props.close)">
        <div v-html-safe="props.item.text" />
        <div
          class="text-center text-cc-overline"
          style="
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            font-size: 7pt !important;
            opacity: 0.6;
          ">
          {{ mobile ? 'TAP' : 'CLICK' }} TO CLOSE
        </div>
      </cc-alert>
    </template>
  </notifications>
</template>

<script lang="ts">
import { useMobile } from '@/mixins/useMobile';
export default {
  mixins: [useMobile],
  name: 'cc-notify',
  methods: {
    color(item) {
      if (item.type) {
        return item.type;
      }
      return item.data?.color || 'info';
    },
    closePopup(close: () => void) {
      close();
    },
  },
};
</script>

<style scoped>
.achievement-pulse {
  animation: talent-pulse 1.7s infinite;
  z-index: 2;
}

@keyframes achievement-pulse {
  0% {
    box-shadow: 0 0 0 0px #d4af37;
  }
  100% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
}
</style>
